/**
 * Chart utilities extracted from mvp/viz/shared.js
 * Adapted for React/TypeScript use with Plotly.js
 */

export function getAllQuestions(survey: any): any[] {
  const questions: any[] = [];

  function extractQuestions(container: any) {
    if (container.questions) {
      container.questions.forEach((q: any) => {
        if (q.type !== 'panel') {
          questions.push(q);
        } else {
          extractQuestions(q);
        }
      });
    }

    if (container.elements) {
      container.elements.forEach((element: any) => {
        if (element.type === 'panel') {
          extractQuestions(element);
        } else if (element.name && element.type) {
          questions.push(element);
        }
      });
    }
  }

  if (survey.pages) {
    survey.pages.forEach((page: any) => extractQuestions(page));
  } else {
    extractQuestions(survey);
  }

  return questions;
}

export function calculateStats(values: number[]): {
  mean: number;
  median: number;
  sd: number;
  min: number;
  max: number;
} {
  if (values.length === 0)
    return { mean: 0, median: 0, sd: 0, min: 0, max: 0 };

  const sorted = [...values].sort((a, b) => a - b);
  const mean = values.reduce((a, b) => a + b, 0) / values.length;
  const median =
    sorted.length % 2 === 0
      ? (sorted[sorted.length / 2 - 1] + sorted[sorted.length / 2]) / 2
      : sorted[Math.floor(sorted.length / 2)];
  const variance =
    values.reduce((sum, val) => sum + Math.pow(val - mean, 2), 0) /
    values.length;
  const sd = Math.sqrt(variance);

  return {
    mean,
    median,
    sd,
    min: sorted[0],
    max: sorted[sorted.length - 1],
  };
}
